import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block space-y-4 w-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full mb-4"
}
const _hoisted_3 = { class: "relative flex items-center w-full h-[22px] max-h-[22px] bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex items-center gap-3 rounded-2xl p-2 bg-white border border-gray-200" }
const _hoisted_6 = { class: "min-w-0 flex-1" }
const _hoisted_7 = { class: "block text-[10px] font-medium tracking-[0.1px] text-parameter-title mb-1.5" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = ["min", "max"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "relative flex items-center w-full h-24 bg-[#f3f0e9] rounded-full p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "relative w-full mt-2"
}
const _hoisted_16 = { class: "relative flex items-center w-full h-20 bg-[#f3f0e9] rounded-2xl p-[2px] border border-[#e8e2d8] select-none" }
const _hoisted_17 = ["title", "onClick", "onMouseenter"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = {
  key: 1,
  class: "w-full aspect-[4/1] overflow-hidden flex items-center justify-center rounded-[11px]"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_23 = ["onClick", "onMouseenter"]
const _hoisted_24 = { class: "block text-[10px] text-gray-500 mt-1 overflow-hidden whitespace-nowrap" }
const _hoisted_25 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_26 = ["onClick", "onMouseenter"]
const _hoisted_27 = { class: "block text-[10px] text-gray-500 mt-1 overflow-hidden whitespace-nowrap" }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { class: "grid grid-cols-5 gap-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "block text-[10px] text-gray-500 mt-2 overflow-hidden" }
const _hoisted_33 = { class: "grid grid-cols-5 gap-2" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "block text-[10px] text-gray-500 mt-1 overflow-hidden" }

import ItemV3ParameterBox from "@/components/itemV3/parameter/itemV3ParameterBox.vue";
import ItemV3ShowMore from "@/components/itemV3/parameter/itemV3ShowMore.vue";
import ItemEngraving from "@/components/itemEngraving.vue";
import {computed, inject, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {ParametersVariations} from "@/assets/ts/parametersVariations";

const imageWidthPercent: number = 10
const boxIdx = "engraving"

const pageStr = "components.itemV2.itemV2Engraving"

const ENGRAVING_ASSET_BASE_URL = "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/engraving/"

const FOCUSED_SYMBOL_COUNT = 5

type EngravingPosition = typeof ENGRAVING_POSITIONS[number]

const sizeVariantIdx = "size"

const namePageStr = "components.itemV2.itemV2Name"

type SpecialFont = typeof SPECIAL_FONTS[number]
type EngravingType = "LASER" | SpecialFont

const COMMIT_ENGRAVING_TEXT_DELAY = 500


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3Engraving',
  props: ["item"],
  emits: ["patch", "update:engraving", "switch:image"],
  setup(__props, { emit: __emit }) {


const {t} = useI18n();

const emit = __emit;
const props = __props;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");
const patchMultiple = inject<any>("patchMultiple");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

// Item whose engraving is displayed/edited here. Defaults to the globally active item, but
// can be switched locally so this widget can show/edit another item's engraving without
// touching the injected itemIdx (which e.g. drives the "discs" list layout in itemV3DiscsColor).
const selectedItemIdx = ref<number>(itemIdx.value)

const items = computed(() => session.value?.items || [])

const itemSliderStyle = computed(() => {
  const count = items.value.length;
  if (count === 0) return {display: 'none'}

  const width = 100 / count;
  const left = selectedItemIdx.value * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
})

const selectItem = (idx: number) => {
  selectedItemIdx.value = idx
}

// Keep following the globally active item by default, without ever pushing the local
// selection back onto itemIdx.
watch(itemIdx, (newIdx) => {
  selectedItemIdx.value = newIdx
})

const loading = ref(false)

/**
 * Parameter box header images
 */

const headerMainMetal = computed(() => store.getters["session/getMainMetal"])
const getHeaderImage = (size: string = "600x300", withBg = false) => {
  if (withBg) {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${headerMainMetal.value}_${boxIdx}.webp`
  } else {
    return `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/menu/${size}/${boxIdx}.webp`
  }
}

/**
 * session
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])

// Tracks the box's own open/closed state (bound via v-model:open below) instead of a
// hardcoded "false", so it survives re-renders triggered by a patch - see
// itemV3ParameterBox.vue's onUpdated hook, which re-asserts this value on every update.
const open = ref(false)


/**
 * image
 */


/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};


/**
 * tip texts
 */

const tipTypeKeys: { [key in EngravingType]: string } = {
  LASER: "laser",
  HANDWRITING: "handwriting",
  FINGERPRINT: "fingerprint",
  OWN_DRAFT: "own_draft"
}

const hoveredType = ref<EngravingType | null>(null)

const previewType = computed<EngravingType>(() => hoveredType.value || selectedType.value)

const setHoveredType = (type: EngravingType) => {
  hoveredType.value = type
}

const clearHoveredType = () => {
  hoveredType.value = null
}

const getTipTitle = computed(() => {
  return t('components.parameters.tips.engraving.' + tipTypeKeys[previewType.value] + '.title')
})

const getTipText = computed(() => {
  return t('components.parameters.tips.engraving.' + tipTypeKeys[previewType.value] + '.text')
})

const getTipImageUrl = computed(() => {
  return 'https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/tips/engraving/' + tipTypeKeys[previewType.value] + '-600.webp'
})

/**
 * engraving
 */

const FOCUSED_FONT_KEYS = ["EnglischeSchT", "MonotypeCorsiva", "PalatinoLinotype"]
const textInput = ref<HTMLElement[] | null>(null);

/**
 * engraving position (inside / outside / left / right)
 */

const ENGRAVING_POSITIONS = ["inside", "outside", "left", "right"] as const
const positionLabelKeys: { [key in EngravingPosition]: string } = {
  inside: "position_inside",
  outside: "position_outside",
  left: "position_left",
  right: "position_right"
}

const selectedPosition = ref<EngravingPosition>("inside")

const positionSliderStyle = computed(() => {
  const count = ENGRAVING_POSITIONS.length;
  const activeIdx = ENGRAVING_POSITIONS.indexOf(selectedPosition.value);
  const width = 100 / count;
  const left = activeIdx * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
})

// position of the small connector arrow that attaches the engraving type
// sub-selector to the currently selected position button
const positionCaretStyle = computed(() => {
  const count = ENGRAVING_POSITIONS.length;
  const activeIdx = ENGRAVING_POSITIONS.indexOf(selectedPosition.value);
  const width = 100 / count;
  const center = activeIdx * width + width / 2;

  return {
    left: `${center}%`,
  };
})

const selectPosition = (position: EngravingPosition) => {
  if (position === selectedPosition.value) {
    return
  }

  selectedPosition.value = position
  clearHoveredFont()
  clearHoveredType()
}

const engraving = computed(() => session.value.engravings[selectedItemIdx.value][selectedPosition.value])

const mainMetal = computed(() => items.value[selectedItemIdx.value]?.image?.main_metal)

/**
 * personal data: item size (logic ported from itemV3PersonalData.vue), tied to whichever
 * item is currently selected via the item switch above.
 */

const sizeParametersVariations = new ParametersVariations(sizeVariantIdx, false, session, selectedItemIdx, loadItemVariants)

const sizeVariants = computed(() => open.value ? sizeParametersVariations.getVariants() : [])

// Explicitly (re)load the "size" variant values for whichever item the user just switched to,
// since the previously selected item's values are cached on the session and won't refresh
// on their own when another item's data hasn't been fetched yet.
watch(selectedItemIdx, (idx) => {
  loadItemVariants(idx, sizeVariantIdx)
})

const sizeActiveIdx = ref(0)

const sizeVariantsList = computed(() => {
  if (!sizeVariants.value.length || sizeVariants.value.length < sizeActiveIdx.value) return []
  return sizeVariants.value[sizeActiveIdx.value].values
})

const sizeActive = computed(() => {
  if (!sizeVariants.value.length || sizeVariants.value.length < sizeActiveIdx.value) return []
  return sizeVariants.value[sizeActiveIdx.value]
})

const sizeMatchedIdx = computed(() => {
  if (!sizeVariants.value.length || sizeVariants.value.length < sizeActiveIdx.value) return 0
  return sizeVariants.value[sizeActiveIdx.value].values.findIndex((v: any) => v.match)
})

/**
 * size input (native number field with min/max/step 0.5, replacing the former slider) -
 * min/max mirror the available "size" variant values, so the native steppers always land
 * on a value the API accepts.
 */

const parseSizeValue = (value: any) => {
  const n = parseFloat(value?.idx)
  return isNaN(n) ? null : n
}

const sizeCurrentValue = computed(() => {
  if (!sizeVariantsList.value.length || sizeMatchedIdx.value < 0) return null
  return sizeVariantsList.value[sizeMatchedIdx.value]
})

const sizeMin = computed(() => sizeVariantsList.value.length ? (parseSizeValue(sizeVariantsList.value[0]) ?? undefined) : undefined)
const sizeMax = computed(() => sizeVariantsList.value.length ? (parseSizeValue(sizeVariantsList.value[sizeVariantsList.value.length - 1]) ?? undefined) : undefined)

// The editable size bound to the input
const sizeModel = ref<number | null>(null)

// Keep sizeModel in sync with the currently matched size value
watch(sizeCurrentValue, (value) => {
  sizeModel.value = parseSizeValue(value)
}, {immediate: true})

/**
 * Patch (size)
 *
 * Uses patchMultiple (instead of the regular @patch emit) so the size of the item currently
 * selected via the item switch is patched, even when it isn't the globally active item.
 */

const handleSizePatch = (actionIdx: string, value: any) => {
  patchMultiple([
    {itemIdx: selectedItemIdx.value, action: actionIdx, value: value.idx}
  ]);
};

// Commits the size input: snaps the typed value into the min/max range, then patches it
// using the matching variant value if one exists (so the exact idx/title the API expects is
// sent), falling back to the formatted raw number otherwise.
const commitSize = () => {
  if (!sizeActive.value || Array.isArray(sizeActive.value) || !sizeVariantsList.value.length) return

  if (sizeModel.value === null || isNaN(sizeModel.value)) {
    // Reset to the currently matched value if the field was cleared
    sizeModel.value = parseSizeValue(sizeCurrentValue.value)
    return
  }

  let value = sizeModel.value
  if (sizeMin.value !== undefined) value = Math.max(sizeMin.value, value)
  if (sizeMax.value !== undefined) value = Math.min(sizeMax.value, value)
  sizeModel.value = value

  const matched = sizeVariantsList.value.find((v: any) => parseSizeValue(v) === value)
  handleSizePatch(sizeActive.value.idx, matched || {idx: value.toFixed(1)})
}

/**
 * personal data: item name (logic ported from itemV3PersonalData.vue), tied to whichever
 * item is currently selected via the item switch above.
 */

const persons = computed(() => session?.value?.persons ?? []);

// Determine which person a given item belongs to; falls back to the item's own index so an
// item without an explicit person association still gets a stable, distinct default name.
const findPersonIdxForItem = (idx: number) => {
  const found = persons.value.findIndex((p: any) => Array.isArray(p.items) && p.items.includes(idx));
  return found >= 0 ? found : idx;
};

// Display name for a given item in the item selection list below, falling back to the
// default person name when no name has been set yet.
const getItemName = (idx: number) => {
  const person = persons.value?.[findPersonIdxForItem(idx)];
  return person?.name || t(namePageStr + '.person_n', {n: idx + 1});
};

const selectedPersonIdx = ref(0);

// Ensure the currently selected item is listed for the selected person (frontend side)
const ensureItemIncluded = () => {
  const p = persons.value?.[selectedPersonIdx.value];
  if (!p) return;
  if (!Array.isArray(p.items)) p.items = [];
  if (!p.items.includes(selectedItemIdx.value)) {
    // Update locally so the UI reflects the association immediately
    p.items.push(selectedItemIdx.value);
    // Persist the association via patch so the backend knows this item belongs to the person
    emit('patch', { action: `person.${selectedPersonIdx.value}.items`, value: p.items, certificated_diamond: true });
  }
};

onMounted(() => {
  selectedPersonIdx.value = findPersonIdxForItem(selectedItemIdx.value);
  ensureItemIncluded();
});

watch(selectedItemIdx, (idx) => {
  selectedPersonIdx.value = findPersonIdxForItem(idx);
  ensureItemIncluded();
});

// The editable name bound to the input
const nameModel = ref("");

// Keep nameModel in sync with selected person
watch(
    () => [selectedPersonIdx.value, persons.value?.[selectedPersonIdx.value]?.name],
    () => {
      const p = persons.value?.[selectedPersonIdx.value];
      nameModel.value = p?.name ?? "";
    },
    {immediate: true}
);

// Emit patch on change as specified: action "person.<person_id>.name" with the name value
const commitName = () => {
  const personId = selectedPersonIdx.value;
  let value = (nameModel.value || "").trim();
  if (!value) {
    // If name is empty, store default name: "Item <person_id>"
    value = t(namePageStr + '.person_n', {n: personId + 1});
    // Reflect the default in the UI immediately
    nameModel.value = value;
  }
  emit('patch', { action: `person.${personId}.name`, value, certificated_diamond: true });
};

/**
 * engraving type (laser / handwriting / fingerprint / own draft)
 */

const SPECIAL_FONTS = ["HANDWRITING", "FINGERPRINT", "OWN_DRAFT"] as const
const typeLabelKeys: { [key in EngravingType]: string } = {
  LASER: "type_laser",
  HANDWRITING: "type_handwriting",
  FINGERPRINT: "type_fingerprint",
  OWN_DRAFT: "type_own_draft"
}

const isSpecialFontAllowed = computed(() => selectedPosition.value === "inside" || selectedPosition.value === "outside")

const engravingTypes = computed<EngravingType[]>(() => {
  if (!isSpecialFontAllowed.value) {
    return ["LASER"]
  }

  return ["LASER", "HANDWRITING", "FINGERPRINT", "OWN_DRAFT"]
})

// "Laser" is always the fallback type: whenever no special font is selected (or special
// fonts aren't allowed for the current position), the type defaults to "Laser" - regardless
// of whether the engraving text is currently empty.
const selectedType = computed<EngravingType>(() => {
  if (isSpecialFontAllowed.value && (SPECIAL_FONTS as readonly string[]).includes(engraving.value.font)) {
    return engraving.value.font as SpecialFont
  }

  return "LASER"
})

const typeSliderStyle = computed(() => {
  const count = engravingTypes.value.length;
  const activeIdx = engravingTypes.value.indexOf(selectedType.value);
  const width = 100 / count;
  const left = activeIdx * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
})

const isLaserSelected = computed(() => selectedType.value === "LASER")

const hoveredFont = ref<string | null>(null)

const previewFontFamily = computed(() => hoveredFont.value || engraving.value.font)

const setHoveredFont = (fontIdx: string) => {
  hoveredFont.value = fontIdx
}

const clearHoveredFont = () => {
  hoveredFont.value = null
}

// Switching between items inside the engraving box should reset the view back to the
// default position: "inside".
watch(selectedItemIdx, () => {
  clearHoveredFont()
  clearHoveredType()
  selectedPosition.value = "inside"
})

const templateFollowsText = computed(() => t(pageStr + ".template_follows"))

const selectType = (type: EngravingType) => {
  if (type === selectedType.value) {
    return
  }

  if (type === "LASER") {
    if (!engraving.value.font || (SPECIAL_FONTS as readonly string[]).includes(engraving.value.font)) {
      engraving.value.font = fontEntries.value[0][0]
    }

    engraving.value.text = ""

    updateFont()

    patchMultiple([
      {
        itemIdx: selectedItemIdx.value,
        action: 'engraving.' + selectedPosition.value + '.font',
        value: engraving.value.font
      },
      {
        itemIdx: selectedItemIdx.value,
        action: 'engraving.' + selectedPosition.value + '.text',
        value: engraving.value.text
      }
    ]);
  } else {
    engraving.value.font = type
    engraving.value.text = templateFollowsText.value

    updateFont()

    patchMultiple([
      {
        itemIdx: selectedItemIdx.value,
        action: 'engraving.' + selectedPosition.value + '.font',
        value: engraving.value.font
      },
      {
        itemIdx: selectedItemIdx.value,
        action: 'engraving.' + selectedPosition.value + '.text',
        value: engraving.value.text
      }
    ]);
  }
}

const engravingFonts: { [key: string]: string } = {
  "Amsterdam": "Amsterdam",
  "ArialSymbols": "Arial",
  "AvantGarde": "Avant Garde",
  "Benguiat": "Benguiat",
  "Berlin": "Berlin",
  "BoereTudor": "Boere Tudor",
  "EdwardianScriptITC": "Edwardian Script ITC (ID: 10)",
  "EnglischeSchT": "Englische SchT (ID: 3)",
  "English111VivaceBT": "English 111 Vivace BT (ID: 11)",
  "FreestyleScript": "Freestyle Script (ID: 16)",
  "PalaceScript": "Palace Script (ID: 4)",
  "Genf": "Genf",
  "Italic": "Italic",
  "Koeln": "Koeln",
  "LegerD": "LegerD (ID: 15)",
  "MonotypeCorsiva": "Monotype Corsiva (ID: 14)",
  "NuptialBT": "Nuptial BT",
  "Oslo": "Oslo",
  "PalatinoLinotype": "Palatino Linotype (ID: 62)",
  "Paris": "Paris",
  "ScriptMTBold": "Script MT Bold",
  "SloganD": "SloganD",
  "TimesNewRoman": "Times New Roman (ID: 2)",
  "Vivaldi": "Vivaldi (ID: 13)"
}

const engravingSymbols: { [key: string]: string } = {
  // a_Herz.dxf
  "heart": "Ⓐ",
  // b_Doppelherz.dxf
  "doubleHeart": "Ⓒ",
  // c_Doppelherz-m-Pfeil.dxf
  "doubleHeartArrow": "Ⓑ",
  // d_Herz-m-Pfreil.dxf
  "heartArrow": "Ⓓ",
  // e_Doppelringe.dxf
  "doubleRings": "Ⓘ",
  // f_Taube.dxf
  "pigeon": "Ⓙ",
  // g_Infinity-Zeichen.dxf
  "infinity": "Ⓕ",
  // h_Herzschloss.dxf
  "heartCastle": "Ⓚ",
  // i_Anker.dxf
  "anchor": "Ⓝ",
  // j_Glaube-Liebe-Hoffnung.dxf
  //"faith": "Ⓔ",
  // k_Amors-Bogen.dxf
  "amorArrow": "Ⓖ",
  // l_Amor.dxf
  "amor": "Ⓗ",
  // m_Krone.dxf
  "crown": "Ⓛ",
  // n_Kutsche.dxf
  //"carriage": "Ⓞ"
}

const fontEntries = computed(() => Object.entries(engravingFonts))
const symbolEntries = computed(() => Object.entries(engravingSymbols))

const focusedFontEntries = computed(() => FOCUSED_FONT_KEYS.map((fontIdx) => [fontIdx, engravingFonts[fontIdx]] as [string, string]))
const overflowFontEntries = computed(() => fontEntries.value.filter(([fontIdx]) => !(FOCUSED_FONT_KEYS as readonly string[]).includes(fontIdx)))

const focusedSymbolEntries = computed(() => symbolEntries.value.slice(0, FOCUSED_SYMBOL_COUNT))
const overflowSymbolEntries = computed(() => symbolEntries.value.slice(FOCUSED_SYMBOL_COUNT))

const formatSymbolName = (symboleIdx: string) => {
  const spaced = symboleIdx.replace(/([a-z])([A-Z])/g, '$1 $2')
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}

const addSymbole = (symboleIdx: string) => {
  const pos = textInput.value?.selectionStart || 0
  const symbole = engravingSymbols[symboleIdx]

  engraving.value.text = engraving.value.text.slice(0, pos) + " " + symbole + " " + engraving.value.text.slice(pos);

  engraving.value.text = engraving.value.text.replace(/ +(?= )/g, '')

  updateFont()

  // showLoading=false: adding a symbol must not trigger the full-screen loading animation,
  // so the user can keep using the field and add more symbols right away.
  patchMultiple([
    {
      itemIdx: selectedItemIdx.value,
      action: 'engraving.' + selectedPosition.value + '.text',
      value: engraving.value.text
    }
  ], false);

}

const selectFont = (fontId: string) => {
  engraving.value.font = fontId;

  updateFont()

  // Cancel any pending debounced text commit (see commitEngravingText) - its text value is
  // sent together with the font below, so a stale later commit would be redundant.
  if (commitEngravingTextTimeout) {
    clearTimeout(commitEngravingTextTimeout)
    commitEngravingTextTimeout = null
  }

  // Always send the current text along with the font: patchMultiple replaces the whole local
  // session with the server's response, so if the text hasn't been committed to the backend yet
  // (e.g. the user just typed it and the debounced commit hasn't fired), omitting it here would
  // cause the server's stale value to wipe out the text the user just typed.
  patchMultiple([
    {
      itemIdx: selectedItemIdx.value,
      action: 'engraving.' + selectedPosition.value + '.font',
      value: engraving.value.font
    },
    {
      itemIdx: selectedItemIdx.value,
      action: 'engraving.' + selectedPosition.value + '.text',
      value: engraving.value.text.trim()
    }
  ]);
}

const updateFont = () => {
  engraving.value.text = engraving.value.text.trim()

  // Only forward the engraving object to the parent when editing the globally active item -
  // the parent assigns it to session.engravings[itemIdx], which must stay untouched for other items.
  if (selectedItemIdx.value === itemIdx.value) {
    emit('update:engraving', engraving.value);
  }
  emit('switch:image', 'Engraving')
}

const onTextInput = () => {
  if (selectedItemIdx.value === itemIdx.value) {
    emit('update:engraving', engraving.value);
  }
  emit('switch:image', 'Engraving')
}

// Delay between the text input losing focus and the text actually being sent to the backend.
// This gives the user enough time to click on a symbol right after typing/leaving the field -
// without the delay, the "change" event could send the text to the API before the symbol click
// is processed, so the newly added symbol would be missing from the saved text.
let commitEngravingTextTimeout: ReturnType<typeof setTimeout> | null = null

const commitEngravingText = () => {
  if (commitEngravingTextTimeout) {
    clearTimeout(commitEngravingTextTimeout)
  }

  commitEngravingTextTimeout = setTimeout(() => {
    commitEngravingTextTimeout = null

    // showLoading=false: committing the engraving text must not trigger the full-screen loading
    // animation, so the user can keep using the field and add more symbols without interruption.
    patchMultiple([
      {
        itemIdx: selectedItemIdx.value,
        action: 'engraving.' + selectedPosition.value + '.text',
        value: engraving.value.text.trim()
      }
    ], false);
  }, COMMIT_ENGRAVING_TEXT_DELAY)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ItemV3ParameterBox, {
    open: open.value,
    "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((open).value = $event)),
    "image-width-percent": imageWidthPercent,
    "header-image": getHeaderImage(),
    "header-image-srcset": getHeaderImage() + ' 300w, ' + getHeaderImage('1200x600') +' 600w',
    title: "Gravur & Größe",
    subtitle: "Wählen Sie die Gravur und die Ringgröße",
    loading: loading.value,
    "tip-title": getTipTitle.value,
    "tip-text": getTipText.value,
    "tip-image": getTipImageUrl.value
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (items.value.length > 1)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                  style: _normalizeStyle(itemSliderStyle.value)
                }, null, 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (ringItem, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: idx,
                    type: "button",
                    class: _normalizeClass(["text-[10px] tracking-wided relative flex-1 flex cursor-pointer items-center justify-center text-xs transition-colors duration-200 z-10 font-normal leading-none h-full", selectedItemIdx.value === idx ? 'text-white font-medium' : 'text-gray-500 hover:text-gray-700']),
                    onClick: ($event: any) => (selectItem(idx))
                  }, _toDisplayString(getItemName(idx)), 11, _hoisted_4))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl text-brand-main" }, [
            _createElementVNode("img", {
              src: "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/engraving/300x300/item_name.webp",
              srcset: "https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/engraving/600x600/item_name.webp",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)(namePageStr + '.article_for')), 1),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameModel).value = $event)),
                onChange: commitName,
                class: "min-w-0 flex-1 text-sm rounded-xl bg-[#faf8f4] px-2.5 py-1.5 border border-[#e7ddcc] transition-colors focus:border-brand-main focus:outline-none"
              }, null, 544), [
                [_vModelText, nameModel.value]
              ]),
              (sizeVariantsList.value.length)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "number",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sizeModel).value = $event)),
                    min: sizeMin.value,
                    max: sizeMax.value,
                    step: "0.5",
                    onChange: commitSize,
                    class: "w-20 shrink-0 text-sm rounded-xl bg-[#faf8f4] px-2.5 py-1.5 border border-[#e7ddcc] transition-colors focus:border-brand-main focus:outline-none"
                  }, null, 40, _hoisted_9)), [
                    [
                      _vModelText,
                      sizeModel.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full text-brand-main transition-colors hover:bg-brand-main hover:text-white",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {commitName(); commitSize()}),
                title: _unref(t)(namePageStr + '.saved')
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5",
                  stroke: "currentColor",
                  class: "h-5 w-5"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M4.5 12.75l6 6 9-13.5"
                  })
                ], -1)
              ]))], 8, _hoisted_10)
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-full transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
              style: _normalizeStyle(positionSliderStyle.value)
            }, null, 4),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ENGRAVING_POSITIONS, (position) => {
              return _createElementVNode("button", {
                key: position,
                type: "button",
                class: _normalizeClass(["relative flex-1 flex flex-col cursor-pointer items-center justify-center transition-opacity duration-200 z-10 h-full", selectedPosition.value === position ? 'opacity-100' : 'opacity-60 hover:opacity-80']),
                title: _unref(t)(pageStr + '.' + positionLabelKeys[position]),
                onClick: ($event: any) => (selectPosition(position))
              }, [
                _createElementVNode("img", {
                  src: ENGRAVING_ASSET_BASE_URL + position + '.svg',
                  alt: _unref(t)(pageStr + '.' + positionLabelKeys[position]),
                  class: "h-16 w-16 object-contain pointer-events-none"
                }, null, 8, _hoisted_14),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[8px] leading-none pointer-events-none", selectedPosition.value === position ? 'text-white' : 'text-gray-600'])
                }, _toDisplayString(_unref(t)(pageStr + '.' + positionLabelKeys[position])), 3)
              ], 10, _hoisted_13)
            }), 64))
          ]),
          (engravingTypes.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "absolute -top-[7px] w-3 h-3 bg-[#f3f0e9] border-l border-t border-[#e8e2d8] rotate-45 z-20 transition-all duration-300 ease-in-out pointer-events-none",
                  style: _normalizeStyle(positionCaretStyle.value)
                }, null, 4),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "absolute top-[2px] bottom-[2px] bg-brand-main rounded-xl transition-all duration-300 ease-in-out shadow-xs pointer-events-none",
                    style: _normalizeStyle(typeSliderStyle.value)
                  }, null, 4),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(engravingTypes.value, (type) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: type,
                      type: "button",
                      class: _normalizeClass(["relative flex-1 flex flex-col items-center justify-center cursor-pointer transition-opacity duration-200 z-10 h-full", selectedType.value === type ? 'opacity-100' : 'opacity-60 hover:opacity-80']),
                      title: _unref(t)(pageStr + '.' + typeLabelKeys[type]),
                      onClick: ($event: any) => (selectType(type)),
                      onMouseenter: ($event: any) => (setHoveredType(type)),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (clearHoveredType()))
                    }, [
                      _createElementVNode("img", {
                        src: ENGRAVING_ASSET_BASE_URL + tipTypeKeys[type] + '.svg',
                        alt: _unref(t)(pageStr + '.' + typeLabelKeys[type]),
                        class: "h-10 w-10 object-contain pointer-events-none"
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-[8px] leading-none overflow-hidden whitespace-nowrap px-1 pointer-events-none", selectedType.value === type ? 'text-white font-medium' : 'text-gray-600'])
                      }, _toDisplayString(_unref(t)(pageStr + '.' + typeLabelKeys[type])), 3)
                    ], 42, _hoisted_17))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (selectedPosition.value === 'inside')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(ItemEngraving, {
                engraving: engraving.value,
                "main-metal": mainMetal.value,
                class: "relative"
              }, null, 8, ["engraving", "main-metal"])
            ]))
          : _createCommentVNode("", true),
        (isLaserSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((engraving.value.text) = $event)),
                ref_key: "textInput",
                ref: textInput,
                onKeyup: onTextInput,
                onChange: commitEngravingText,
                class: "text-base block w-full bg-white p-2 rounded-[11px] border border-brand-main",
                style: _normalizeStyle({fontFamily: previewFontFamily.value})
              }, null, 36), [
                [_vModelText, engraving.value.text]
              ])
            ]))
          : _createCommentVNode("", true),
        (isLaserSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(focusedFontEntries.value, ([fontIdx, fontName]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: fontIdx,
                    class: _normalizeClass(["cursor-pointer p-2 text-center overflow-hidden rounded-[11px] border border-brand-main", engraving.value.font === fontIdx ? 'border-brand-main border bg-[#f3f0e9]' : 'border-white bg-white']),
                    onClick: ($event: any) => (selectFont(fontIdx)),
                    onMouseenter: ($event: any) => (setHoveredFont(fontIdx)),
                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (clearHoveredFont()))
                  }, [
                    _createElementVNode("span", {
                      class: "block text-sm overflow-hidden whitespace-nowrap",
                      style: _normalizeStyle({fontFamily: fontIdx})
                    }, _toDisplayString(engraving.value.text || 'Aa'), 5),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(fontName), 1)
                  ], 42, _hoisted_23))
                }), 128))
              ]),
              (overflowFontEntries.value.length > 0)
                ? (_openBlock(), _createBlock(ItemV3ShowMore, { key: 0 }, {
                    "more-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(pageStr + '.show_all')), 1)
                    ]),
                    "less-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(pageStr + '.show_less')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overflowFontEntries.value, ([fontIdx, fontName]) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: fontIdx,
                            class: _normalizeClass(["cursor-pointer p-2 text-center overflow-hidden rounded-[11px] border border-brand-main", engraving.value.font === fontIdx ? 'border-brand-main border bg-[#f3f0e9]' : 'border-white bg-white']),
                            onClick: ($event: any) => (selectFont(fontIdx)),
                            onMouseenter: ($event: any) => (setHoveredFont(fontIdx)),
                            onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (clearHoveredFont()))
                          }, [
                            _createElementVNode("span", {
                              class: "block text-sm overflow-hidden whitespace-nowrap",
                              style: _normalizeStyle({fontFamily: fontIdx})
                            }, _toDisplayString(engraving.value.text || 'Aa'), 5),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(fontName), 1)
                          ], 42, _hoisted_26))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (isLaserSelected.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(focusedSymbolEntries.value, ([symboleIdx]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: symboleIdx,
                    class: "cursor-pointer p-2 bg-white border border-white hover:bg-gray-100 text-center flex flex-col items-center justify-start rounded-[11px] hover:border hover:border-brand-main",
                    onClick: ($event: any) => (addSymbole(symboleIdx))
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/symbols/' + symboleIdx + '.png'),
                      alt: symboleIdx,
                      class: "w-aut h-6"
                    }, null, 8, _hoisted_31),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(formatSymbolName(symboleIdx)), 1)
                  ], 8, _hoisted_30))
                }), 128))
              ]),
              (overflowSymbolEntries.value.length > 0)
                ? (_openBlock(), _createBlock(ItemV3ShowMore, { key: 0 }, {
                    "more-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(pageStr + '.show_all')), 1)
                    ]),
                    "less-label": _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(pageStr + '.show_less')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overflowSymbolEntries.value, ([symboleIdx]) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: symboleIdx,
                            class: "cursor-pointer p-2 bg-white border border-white hover:bg-gray-100 text-center flex flex-col items-center justify-center rounded-[11px] hover:border hover:border-brand-main",
                            onClick: ($event: any) => (addSymbole(symboleIdx))
                          }, [
                            _createElementVNode("img", {
                              src: require('@/assets/img/symbols/' + symboleIdx + '.png'),
                              alt: symboleIdx,
                              class: "w-8 h-auto"
                            }, null, 8, _hoisted_35),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(formatSymbolName(symboleIdx)), 1)
                          ], 8, _hoisted_34))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["open", "header-image", "header-image-srcset", "loading", "tip-title", "tip-text", "tip-image"]))
}
}

})